module.exports = "<app-mark-classification-type-list></app-mark-classification-type-list>"